"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeLocationObject = void 0;
const query_string_1 = __importDefault(require("query-string"));
const makeLocationObject = (location) => {
    const query = query_string_1.default.parse(location.search);
    const nodeId = query.displayNode ? query.displayNode : 'all';
    const txnId = query.txnId ? query.txnId : null;
    const showCalendarUI = (query === null || query === void 0 ? void 0 : query.displayMode) === 'calendar';
    return Object.assign({ selectedAccountNodeId: nodeId, location, firstTxnId: txnId }, (showCalendarUI || txnId !== null ? { showCalendarUI } : {}));
};
exports.makeLocationObject = makeLocationObject;
